const isPageBuilder = document.body.classList.contains(
  'KenticoAdminPageBuilder'
);

// On mobile the slider switches to a scrollable list
const isDesktopQuery = window.matchMedia('(min-width: 601px)');

// Store event handlers outside of init function
// so that we can properly reset everything when
// slides are added/removed inside Page Builder
let count = 0;
let eventListeners = [];

function initSliders() {
  if (eventListeners.length) {
    document.querySelectorAll('.tab-button').forEach(button => {
      eventListeners.forEach(listener =>
        button.removeEventListener('click', listener)
      );
    });
  }

  count = 0;
  eventListeners = [];

  document.querySelectorAll('.tab-slider').forEach(slider => {
    slider.classList.add('no-animation');

    const slides = Array.from(slider.querySelectorAll('.tab-wrapper'));

    if (slides.length <= 1) {
      if (slides.length === 1) slides[0].classList.add('open');
      setTimeout(() => slider.classList.remove('no-animation'), 100);
      return;
    }

    slider.style.setProperty('--tab-count', slides.length);

    const buttons = slider.querySelectorAll('.tab-button');

    const setAccessibilityAttributes = () => {
      if (isDesktopQuery.matches) {
        const buttonIds = [];

        buttons.forEach(el => {
          const slide = el.closest('.tab-wrapper');
          const isActive = slide?.classList.contains('open') ?? false;

          if (el.id) buttonIds.push(el.id);

          el.setAttribute('aria-selected', isActive);
          el.tabIndex = isActive ? -1 : 0;
          el.disabled = isActive;
        });

        slider.setAttribute('role', 'tablist');

        if (buttonIds.length) {
          slider.setAttribute('aria-owns', buttonIds.join(' '));
        }

        slider.querySelectorAll('.tab-content-wrapper').forEach(el => {
          el.setAttribute('role', 'tabpanel');
        });
      } else {
        slider.removeAttribute('role');
        slider.removeAttribute('aria-owns');
        slider.querySelectorAll('.tab-content-wrapper').forEach(el => {
          el.removeAttribute('role');
        });
      }
    };

    // Add or remove accessibility attributes based on desktop/mobile
    if (isDesktopQuery.addEventListener) {
      isDesktopQuery.addEventListener('change', setAccessibilityAttributes);
    } else if (isDesktopQuery.addListener) {
      isDesktopQuery.addListener(setAccessibilityAttributes);
    }

    const setCurrentSlide = (slide, button) => {
      slide ??= button?.closest('.tab-wrapper');
      button ??= slide?.querySelector('.tab-button');

      if (!button || !slide) return;

      slides.forEach(el => el.classList.toggle('open', el === slide));

      setAccessibilityAttributes();

      if (isPageBuilder) {
        slider.dataset.activeTab = slides.indexOf(slide);
      }
    };

    const handleButtonClick = e => {
      const button = e.target;
      const slide = button?.closest('.tab-wrapper');

      if (!button || !slide || slide.classList.contains('open')) return;

      setCurrentSlide(slide, button);

      // If clicked from keyboard, blur the button
      // to remove the focus outline when active
      if (e.detail === 0) setTimeout(() => button.blur(), 5);
    };

    eventListeners.push(handleButtonClick);

    let hasOpenSlide = false;

    buttons.forEach(button => {
      const wrapper = button.closest('.tab-wrapper');
      if (!wrapper) return;

      const isOpen = wrapper.classList.contains('open');

      if (isOpen) hasOpenSlide = true;

      button.addEventListener('click', handleButtonClick);
      button.tabIndex = isOpen ? -1 : 0;
      button.disabled = button.setAttribute('aria-selected', isOpen);

      // Set accessibility items
      count++;

      const content = wrapper.querySelector('.tab-content-wrapper');

      button.id ||= `tab-button-${count}`;

      if (content) {
        const id = `tab-${count}`;

        content.id = id;
        button.setAttribute('aria-controls', id);
      }
    });

    setAccessibilityAttributes();

    if (!hasOpenSlide) {
      slider.classList.add('no-animation');

      const activeTab = isPageBuilder
        ? parseInt(slider.dataset.activeTab) || 0
        : 0;

      setCurrentSlide(slides[activeTab] ?? slides[0]);
    }

    setTimeout(() => slider.classList.remove('no-animation'), 100);
  });
}

initSliders();

if (isPageBuilder) {
  let pageBuilderTimer = null;

  window.addEventListener('fremont:tab-slider-change', () => {
    clearTimeout(pageBuilderTimer);
    pageBuilderTimer = setTimeout(initSliders, 100);
  });
}
